import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {apiClient} from '@common/http/query-client';

export interface SendPhoneUpdateMobileOtpPayload {
  code: string;
  mobile_number: string;
}

export function useSendPhoneUpdateMobileOtp(
  form: UseFormReturn<SendPhoneUpdateMobileOtpPayload>,
) {
  return useMutation({
    mutationFn: (payload: SendPhoneUpdateMobileOtpPayload) => sendOtp(payload),
    onError: err => onFormQueryError(err, form),
  });
}

function sendOtp(payload: SendPhoneUpdateMobileOtpPayload) {
  return apiClient
    .post('phone-update/send-mobile-otp', payload)
    .then(response => response.data);
}
